import PropTypes from 'prop-types'
import Moment from 'moment'

/**
 * @deprecated Please import { intervalDatePropType } from '@wf/datetime'
 */
export const intervalPropType = PropTypes.shape({
    end: PropTypes.instanceOf(Moment).isRequired,
    start: PropTypes.instanceOf(Moment).isRequired
})
